import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PassengersReportService } from '../../services/passengers-report.service';
import { CommonService } from '../../services/common.service';
import { Alertreportservice } from '../../services/alertreport.service';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExcelService } from '../../services/excel.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


declare var $: any;
@Component({
  selector: 'app-alert-report',
  templateUrl: './alert-report.component.html',
  styleUrls: ['./alert-report.component.css']
})
export class AlertReportComponent implements OnInit {

  alarmTypes: any = [];
  plates: any = [];
  drivers: any = [];


  platesBuffer = [];
  bufferSize = 50;
  user_account: any;
  imeiVei: any = {};
  reportAux: any = [];
  alarmTypeid: any = [];
  dataObj: any = [];
  dataReport: MatTableDataSource<any>;
  report: any = [];
  totalIn: any;
  totalOut: any;
  promTot: any;
  totalProm: any;

  alarmTypesDropdownSettings: any = {};
  selectedAlarmTypes: any = []

  driversDropdownSettings: any = {};
  selectedDrivers: any = []

  platesDropdownSettings: any = {};
  selectedPlates: any = []
  currentPlate = ""
  displayedColumns: string[];
  filterMenuVisible: boolean = false;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private spinner: NgxSpinnerService,
    private vpcReportService: PassengersReportService,
    private alertReportService: Alertreportservice,
    private commonService: CommonService,
    private excelService: ExcelService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }


  ngOnInit() {
    var now = new Date(); //currentDate
    this.reportAux.dateIni = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.reportAux.dateFin = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.reportAux.timeIni = '00:00';
    this.reportAux.timeFin = '23:59';
    this.setAlarmTypesDropDown();

    // Seteal el selector de placas con todas seleccionadas
    this.route.queryParams.subscribe(params => {
      if (params.plate != undefined) {
        this.selectedPlates.push({ 'tracker_name': params.plate });
      }
    });
    this.setPlatesDropDown();
    this.setDriversDropDown();

  }

  ngAfterViewInit() {
    // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
    $(".mat-paginator-page-size").css("display", "none")
  }

  setPlatesDropDown() {
    this.platesDropdownSettings = {
      singleSelection: false,
      idField: 'sn_imei_id',
      textField: 'tracker_name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };
    this.getPlates();

  }

  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }


  toAlertUbication(lat, long, plate, alarm, driver) {
    this.router.navigate(['/home/alarmubication'],
      {
        queryParams:
        {
          lat: lat,
          long: long,
          plate: plate,
          alarm: alarm,
          driver: driver
        }
      });
  }

  async setAlarmTypesDropDown() {
    this.getAlarmTypes()
    this.alarmTypesDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'description',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };
  }

  async setDriversDropDown() {
    await this.getDrivers()
    this.driversDropdownSettings = {
      singleSelection: false,
      idField: 'identificationDriver',
      textField: 'nameDriver',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };
  }


  onAlarmTypeSelect(item: any) {
    console.log(this.selectedAlarmTypes)
  }
  onAlarmTypeDeSelect(item: any) {
    console.log(this.selectedAlarmTypes)

  }
  onSelectAllAlarmTypes(items: any) {
    console.log(this.selectedAlarmTypes)
  }
  onDeSelectAllAlarmTypes(items: any) {
    console.log(this.selectedAlarmTypes)
  }

  onPlateSelect(item: any) {
    // this.selectedPlates.push(item.tracker_name)
    console.log(this.selectedPlates)
  }
  onSelectAllPlates(items: any) {
    console.log(this.selectedPlates)

  }
  onPlatesDeSelect(item: any) {
    console.log(this.selectedPlates)

  }
  onDeSelectAllPlates(item: any) {
    console.log(this.selectedPlates)
  }

  getAlarmTypes(): void {
    this.alertReportService.getAlarmTypes(this.commonService.getUserName()).then(response => {
      this.alarmTypes = response;
      // this.selectedAlarmTypes = response
      this.alarmTypes.sort(function (a, b) {
        if (a.description > b.description) {
          return 1;
        }
        if (a.description < b.description) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
    });
  }

  getDrivers(): void {
    this.alertReportService.getDrivers_rol().then(response => {
      console.log(response)
      this.drivers = response;
      this.drivers.sort(function (a, b) {
        if (a.nameDriver > b.nameDriver) {
          return 1;
        }
        if (a.nameDriver < b.nameDriver) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      // this.selectedDrivers = response;
    });
  }

  getPlates(): void {
    this.vpcReportService.getPlates(this.commonService.getUserName()).then(response => {
      this.plates = response;
      for (var i in this.plates) {
        this.plates[i].tracker_name = this.plates[i].tracker_name + " - " + this.plates[i].license_plate
      }
    });
  }

  getSelectedDates() {
    var d1, m1, d2, m2;
    if (this.reportAux.dateIni.day < 10) {
      d1 = '0' + this.reportAux.dateIni.day;
    } else {
      d1 = this.reportAux.dateIni.day;
    }
    if (this.reportAux.dateIni.month < 10) {
      m1 = '0' + this.reportAux.dateIni.month;
    } else {
      m1 = this.reportAux.dateIni.month;
    }
    var dateIni = d1 + '-' + m1 + '-' + this.reportAux.dateIni.year + ' ' + this.reportAux.timeIni;

    if (this.reportAux.dateFin.day < 10) {
      d2 = '0' + this.reportAux.dateFin.day;
    } else {
      d2 = this.reportAux.dateFin.day;
    }
    if (this.reportAux.dateFin.month < 10) {
      m2 = '0' + this.reportAux.dateFin.month;
    } else {
      m2 = this.reportAux.dateFin.month;
    }
    var dateFin = d2 + '-' + m2 + '-' + this.reportAux.dateFin.year + ' ' + this.reportAux.timeFin;
    dateIni = dateIni.replace(':', '_');
    dateFin = dateFin.replace(':', '_');

    return { dateIni: dateIni, dateFin: dateFin }
  }

  // getselectedPlates() {
  //   var platesString = []
  //   for (var i in this.selectedPlates) {
  //     platesString.push(this.selectedPlates[i].tracker_name.split(" - ")[0])
  //   }
  //   if (platesString.length == 0) {
  //     platesString.push("-")
  //   }
  //   return platesString;
  // }

  // getSelectedAlarmTypes() {
  //   var alarmTypesString = []
  //   for (var i in this.selectedAlarmTypes) {
  //     alarmTypesString.push(this.selectedAlarmTypes[i].id)
  //   }
  //   if (alarmTypesString.length == 0) {
  //     alarmTypesString.push("-")
  //   }
  //   return alarmTypesString
  // }

  // getSelectedDrivers() {
  //   var driversString = []
  //   for (var i in this.selectedDrivers) {
  //     driversString.push(this.selectedDrivers[i].identificationDriver)
  //   }
  //   if (driversString.length == 0) {
  //     driversString.push("-")
  //   }
  //   return driversString
  // }

  applyFilter(filterValue: string) {
    this.dataReport.filter = filterValue.trim().toLowerCase();

    if (this.dataReport.paginator) {
      this.dataReport.paginator.firstPage();
    }
  }

  sortData(e) {
    console.log(e)
  }

  setTable(data) {
    this.displayedColumns = ["plate",
      'identificationDriver',
      'nameDriver',
      'l_datetime',
      "alarm",
      "message",
      "speed",
      'ubication'];
    
    this.dataReport = new MatTableDataSource(data);
    this.dataReport.paginator = this.paginator;
    this.dataReport.paginator._intl.itemsPerPageLabel = "Filas por Página:"
    // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
    $(".mat-paginator-page-size").css("display", "none")

    this.dataReport.sort = this.sort;
  }

  loadReport(): void {
    this.spinner.show();
    this.dataObj = [];
    var dates = this.getSelectedDates();

    var platesString = this.selectedPlates.map(({ sn_imei_id }) => "'" + sn_imei_id + "'").toString();
    var alarmTypesString = this.selectedAlarmTypes.map(({ id }) => "'" + id + "'").toString();
    var driversString = this.selectedDrivers.map(({ identificationDriver }) => "'" + identificationDriver + "'").toString();

    this.alertReportService.getReport(
      platesString.toString(),
      alarmTypesString.toString(),
      driversString.toString(),
      dates.dateIni,
      dates.dateFin
    )
      .then(data => {
        console.log('data : ', data)
        this.spinner.hide();

        // $('.tbodyTable').empty();
        // this.spinner.hide();

        this.report = data;
        // const dateValidate = new Date('2018-01-01 00:00:00.00');
        // const dateValidateSum = new Date('2018-01-01 00:00:00.00');
        // let trip = 0;
        let totalIn = 0;
        let totalOut = 0;
        let promTot = 0;

        // const quant = parseInt(data.length) - 1;
        const quant = parseInt(data.length);
        if (quant > 0) {
          $('.tbodyTable').empty();
          for (let i = 0; i < data.length; i++) {
            data[i].l_datetime = new Date(data[i].l_datetime)
            data[i].l_datetime = data[i].l_datetime.toLocaleString('es-CO', { hour12: true })
            // data[i].trip = trip
            // const dateArray = new Date(data[i].startdate);
            // if (dateArray < dateValidate || dateArray > dateValidateSum) {
            var it = {};
            // trip = trip + 1
            // data[i].trip = trip
            data[i].location = '<a><i class="la la-rss la-2x"></i></a>'
            it["Placa"] = data[i].plate;
            it["Identificación Conductor"] = data[i].identificationDriver;
            it["Nombre Conductor"] = data[i].nameDriver;
            it["Fecha"] = data[i].l_datetime;
            it["Alarma"] = data[i].description;
            it["Puertas"] = data[i].message;
            it["Velocidad"] = data[i].speed;
            // it["Ubicación"] = data[i].location

            // this.dataReport.push(data[i]);
            this.dataObj.push(it);
            // }
            event.preventDefault();
          }
          setTimeout(() => { this.setTable(data) }, 2000);
          
        } else {
          this.spinner.hide();
          $('.tbodyTable').empty();
          swal({
            title: 'No existen datos para este rango de fechas',
            text: '',
            type: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#ff5370',
            confirmButtonText: 'Volver',
            // cancelButtonText: 'No'
          }).catch(swal.noop);
        }

      })
      .catch(error => {
        console.log(error)
        this.spinner.hide();
        // console.log('vpcReport.component.error');
        swal({
          title: 'No es posible realizar la consulta, comuníquese con el administrador del sistema',
          text: '',
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
      });
  }

  exportToExcel() {
    if (this.dataObj.length > 0) {
      this.excelService.exportAsExcelFile(this.dataObj, 'reporte_alarmas');
    } else {
      swal({
        title: 'No hay datos para exportar',
        text: '',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/alert-report/alert-report.component.ts